// extracted by mini-css-extract-plugin
module.exports = {"bottomInfoWrapper":"styles_bottomInfoWrapper__3phxT"};